import {
  getGsiteValueFromUrl,
  getVfValueFromUrl
} from '../offer/business/privateDeals'
import {isHotelAdsVerifier} from './userAgent'

export {isHotelAdsVerifier} from './userAgent'

export const GSITE_RATE_CHECKER_IDENTIFIER = 'verification'

/**
 * Whether the URL carries a rate-checker marker: `gsite=verification`, `vf=1`
 * or `vf=true`, either as a direct parameter or encoded inside `label`.
 * @param searchParams - The parsed URL query
 */
export const isRateChecker = <T extends Record<string, unknown>>(
  searchParams: T
) => {
  const gsiteParam = getGsiteValueFromUrl(searchParams)
  const vfParam = getVfValueFromUrl(searchParams)
  return (
    gsiteParam === GSITE_RATE_CHECKER_IDENTIFIER ||
    vfParam === 'true' ||
    vfParam === '1'
  )
}

/**
 * `automated-checker` is Google's verifier user agent. `human-checker` is a
 * URL marker without that user agent, see {@link isRateChecker}.
 */
export type GhaClassification =
  | 'regular'
  | 'human-checker'
  | 'automated-checker'

interface GhaVisitorInputs {
  userAgent: string | null | undefined
  searchParams: Record<string, unknown>
}

/**
 * Classifies a Google Hotel Ads visit from its request inputs. The verifier
 * user agent wins over URL markers.
 * @param inputs - The request's user agent and parsed URL query
 */
export const classifyGhaVisitor = (
  inputs: GhaVisitorInputs
): GhaClassification => {
  if (isHotelAdsVerifier(inputs.userAgent)) return 'automated-checker'
  if (isRateChecker(inputs.searchParams)) return 'human-checker'
  return 'regular'
}
